import { render } from "./base-navmenu.vue?vue&type=template&id=21989dd9&scoped=true&ts=true"
import script from "./base-navmenu.vue?vue&type=script&lang=ts"
export * from "./base-navmenu.vue?vue&type=script&lang=ts"

import "./base-navmenu.vue?vue&type=style&index=0&id=21989dd9&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21989dd9"]])

export default __exports__